import { Component, OnInit, OnDestroy } from '@angular/core';

import { of, tap, filter, switchMap, catchError, Subscription, take } from 'rxjs';

import { FrontendModalService } from '@tablesready/frontend-modal';
import {
  ConfirmationModalComponent,
  ConfirmationModalResult,
} from '@tablesready/common-ui';
import { InviteApiService } from '../../../../../services';
import { ProfileInvitesService } from '../../services';
import { AccountAccess } from '@tablesready/frontend-status-bar';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'tablesready-accounts-access',
  templateUrl: './accounts-access.component.html',
})
export class AccountsAccessComponent implements OnInit, OnDestroy {
  accounts: AccountAccess[] = [];
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly inviteApiService: InviteApiService,
    private readonly inviteDataService: ProfileInvitesService,
    private readonly alertsService: AlertsService,
    private readonly modalController: FrontendModalService,
  ) { }

  ngOnInit() {
    const inviteDataSubscription = this.inviteDataService.get()
      .pipe(tap(accounts => this.accounts = accounts))
      .subscribe();
    this.subscriptions.add(inviteDataSubscription);
    this.subscriptions.add(this.inviteDataService.listenToChanges().subscribe());
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  acceptInvite(inviteId: string): void {
    this.inviteApiService.accept(inviteId)
      .pipe(
        tap(() => this.alertsService.addSuccess('accepted')),
        catchError(() => {
          this.alertsService.addError('an error occurred during accepting invite');

          return of(null);
        }),
      )
      .subscribe();
  }

  declineInvite(inviteId: string): void {
    this.modalController.create<ConfirmationModalComponent, ConfirmationModalResult<boolean>>(ConfirmationModalComponent, {
      options: {
        title: 'Decline invite',
        content: 'Are you sure to decline this invite?',
      },
    })
      .pipe(
        take(1),
        filter((res) => res?.response),
        switchMap(() => this.inviteApiService.decline(inviteId)),
        tap(() => this.alertsService.addSuccess('declined')),
        catchError(() => {
          this.alertsService.addError('an error occurred during decline invite.');

          return of(null);
        }),
      )
      .subscribe();
  }
}
